import { render, staticRenderFns } from "./VoteDuo.vue?vue&type=template&id=05bf9dd3&scoped=true"
import script from "./VoteDuo.vue?vue&type=script&lang=js"
export * from "./VoteDuo.vue?vue&type=script&lang=js"
import style0 from "./VoteDuo.vue?vue&type=style&index=0&id=05bf9dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf9dd3",
  null
  
)

export default component.exports